/*jshint esversion: 6 */

import $ from 'jquery';
import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

class LogoCarousel {

  constructor($main) {
    if (!this.initDomElements($main)) return false;

    this.domElements.items.slick({
      infinite: true,
      adaptiveHeight: false,
      autoplay: true,
      fade: false,
      pauseOnHover: false,
      dots: false,
      appendDots: this.domElements.contentInside,
      appendArrows: this.domElements.content,
      speed: 500,
      autoplaySpeed: 3000,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        }
      ],
    });
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.items = this.domElements.main.find('.logo-carousel__items');
    this.domElements.content = this.domElements.main.find('.logo-carousel__content');
    this.domElements.contentInside = this.domElements.main.find('.logo-carousel__content__inside');

    return true;
  }

}

export default LogoCarousel;
